/**
 * Legacy Cuba template auth routes removed — use /login (Signin) only.
 */
export const authRoutes = [];
